import { ChangeDetectionStrategy, Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InstructionOrder } from 'src/app/order/model/instruction-order';

@Component({
  selector: 'app-instruction-dialog',
  templateUrl: './instruction-dialog.component.html',
  styleUrls: ['./instruction-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstructionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InstructionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { instructions: InstructionOrder[] },
    private cdr: ChangeDetectorRef
  ) {}

  onClose(): void {
    this.dialogRef.close(this.data);
    this.cdr.detectChanges();
  }
}
